enum SortDirection {
    DESC = 'DESC',
    ASC = 'ASC',
}

export { SortDirection };
